import { useState, useEffect } from 'react';

export type CompetitionScope = 'branch' | 'company' | 'commercial_group';

const STORAGE_KEY = 'competition-scope-preference';

export function useCompetitionScope() {
  const [scope, setScope] = useState<CompetitionScope>(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return (saved as CompetitionScope) || 'company';
  });

  const updateScope = (newScope: CompetitionScope) => {
    setScope(newScope);
    localStorage.setItem(STORAGE_KEY, newScope);
  };

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        setScope(e.newValue as CompetitionScope);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return {
    scope,
    setScope: updateScope,
    isCompanyScope: scope === 'company',
    isBranchScope: scope === 'branch',
    isCommercialGroupScope: scope === 'commercial_group'
  };
}